import * as React from 'react';

import * as styles from './Marquee.css';

export interface IMarqueeProps {
  text: string;
}

/* Компонент бегущей строки, которая бежит только при наведении */
export const Marquee: React.FC<IMarqueeProps> = ({ text }) => {
  const container = React.useRef<HTMLDivElement>(null);

  const mouseOverHandler = (event: React.MouseEvent<HTMLDivElement>) => {
    /* istanbul ignore else */
    if (container.current) {
      const target = event.target as HTMLSpanElement;
      const containerWith = container.current.offsetWidth;
      const childWith = target.offsetWidth;

      const diff = childWith - containerWith;

      if (diff > 0) {
        target.style.transition = `transform ${diff / 100}s linear`;
        target.style.transform = `translate(-${diff}px, 0)`;
      }
    }
  };

  const mouseLeaveHandler = (event: React.MouseEvent<HTMLDivElement>) => {
    const target = event.target as HTMLSpanElement;

    target.style.transform = '';
    target.style.transition = '';
  };

  return (
    <div
      data-testid="marquee"
      ref={container}
      className={styles['container']}
      onMouseOver={mouseOverHandler}
      onMouseLeave={mouseLeaveHandler}
    >
      <span className={styles['text']} data-testid="MarqueeText">
        {text}
      </span>
    </div>
  );
};
